/**
 * @file ResumeBookmarkPlacement.ts
 *
 * @fileoverview Exports resume bookmark possible placements enum.
 */
export enum ResumeBookmarkPlacement {
  RESUME_TEASER = 'resume teaser',
  RESUME_DETAIL = 'resume detail',
}
export default ResumeBookmarkPlacement;
